
import { NavigationTranslationType } from "../../features/navigation.types";

export const navigation: NavigationTranslationType = {
  navigation: {
    dashboard: "Tableau de bord",
    profile: "Profil",
    signOut: "Déconnexion",
    upgradeRequired: "Mise à niveau requise",
    basicSubscriptionRequired: "Abonnement de base requis",
    premiumSubscriptionRequired: "Abonnement premium requis",
  }
};
